(function () {

    // inject ui.bootstrap
    angular.module("SUGApp").requires.push('ui.bootstrap');

    SUGApp.factory('loginfactory', ['SUGUtilities', '$sce', 'loginservice', '$uibModal', '$window', 'authenticationService', '$filter', '$location', '$timeout', '$q', function (util, sce, svc, modal, win, authSvc, filter, location, timeout, $q) {

        var service = {};
        service.getLogin = function (disableRegistration, showregistrationfirst) {
            var s = {};
            s.allowRegistration = disableRegistration ? false : true;
            s.showregistrationfirst = showregistrationfirst ? showregistrationfirst : false; //controls if it should default to registration screen instead
            s.h = new Date().getTime();
            s.user = {};
            s.user.loggedin = false;
            s.attrs = {};
            s.asyncSuccess = true;
            s.success = true;
            s.errorMessages = {};
            s.fbAppId = '';
            s.objForm = {};
            s.objForm.listid = 0;
            s.objForm.owner = 0;
            s.objForm.urlid = utility.getUrlParamValue('urlid'); // utility is available globally
            s.objForm.siid = '';
            s.objForm.imid = 0;
            s.objForm.usealternatename = false;
            s.objForm.changemembermame = false;
            s.objForm.displayfirstname = '';
            s.objForm.displaylastname = '';
            s.objForm.firstname = '';
            s.objForm.lastname = '';
            s.objForm.email = '';
            s.objForm.savecontactinfo = false;

            s.labels = {
                "cancelBtn": "Cancel",
                "deleteBtn": "Delete",
                "breadcrumbBtn": "Back to ",
                "contactinfo": "Contact info:",
                "additionalinfo": "Additional info:"
            };

            s.standardErrors = {
                "email_invalid": "You must enter a valid email address.",
                "email_length": "Email address must not exceed 100 characters.",
                "firstname_length": "First name must not exceed 50 charcters.",
                "lastname_length": "Last name must not exceed 100 characters.",
                "quantity_invalid": "The quantity must be all numeric.",
                "savecontactinfo": "You must populate the address and/or phone information when selecting this option."
            };

            s.errormessage = "Oops! Something went wrong. We can't seem to find the sign up information you've requested. If this error persists, please <a href='/help'>contact support</a>.";

            /** helper method for updating top navigation menu **/
            var updateMenu = function () {
                svc.getMainNavigation()
                    .then(function (response) {
                        var r = util.lowerCaseKeys(response);
                        if (!resultCheck(r.data)) {
                            errorHandler(r.data);
                        } else {
                            var menu = angular.element(document.querySelector('#main-nav'));
                            menu.empty(); // remove existing menu
                            menu.append(r.data.data); // append the new menu
                        }
                    });
            };

            var elemLenCheck = function (elem) {
                return isD(s.objForm[elem]) ? s.objForm[elem].toString().trim().length : 0;
            };

            var resultCheck = function (response) {
                var result = util.lowerCaseKeys(response);
                try {
                    return (angular.isDefined(result.success) && result.success && angular.isDefined(result.data));
                } catch (e) {
                    return false;
                }
            };

            var errorHandler = function (response) {
                var errMessage = svc.resultErrorHandler(response);
                util.showMagnificAlert(errMessage);
            };

            /** helper method for converting values to float **/
            var toFloat = function (val) {
                return typeof val !== "undefined" && val !== "" ? parseFloat(parseFloat(val.toString().replace(',', '')).toFixed(2)) : 0.00;
            };

            /** helper method for lower casing strings **/
            var lowerCaseIt = function (str) {
                return str.toString().toLowerCase().trim();
            };

            /** helper method for checking if a variable or key is defined **/
            var isD = function (key) {
                return angular.isDefined(key);
            };

            /** logout method **/
            s.logout = function () {
                s.asyncSuccess = true;
                authSvc.logoutUser()
                    .then(function (response) {
                        var r = util.lowerCaseKeys(response);
                        if (!resultCheck(r.data)) {
                            s.asyncSuccess = false;
                            errorHandler(r.data);
                        } else {
                            s.user = {};
                            s.user.loggedin = false;
                            if (isD(s.attrs.thismemberid))
                                delete s.attrs.thismemberid;
                            if (isD(s.attrs.mid))
                                delete s.attrs.mid;

                            // update upper main navivation menus
                            updateMenu();
                        }
                    })
                    .finally(() => {
                        window.sugTagManager.reset();
                    });
            };

            s.preplogin = function ( required, destination, allowregister, showregister ) {
                // possible overrides for forcing user to Register (part of email gating changes)
                s.allowRegistration = allowregister ? allowregister : true;
                s.showregistrationfirst = showregister ? showregister : false;

                svc.getUserInfo().then(
                    function( response ){
                        var r = util.lowerCaseKeys( response );

                        if ( !r.data ) {
                            //switch to https

                            //show login window in https
                            s.login( required, destination, s.allowRegistration, s.showregistrationfirst );
                        } else if (r.data.data ) {

                            if (r.data.data.memberid > 0 && destination !== undefined && destination !== '' ) {
                                win.location.href = destination;
                            } else {
                                s.login( required, destination, s.allowRegistration, s.showregistrationfirst );
                            }
                        } else {
                            s.login( required, destination, s.allowRegistration, s.showregistrationfirst );
                        }
                    }
                );
            };

            /**
             * login method
             * Spawns a modal that shows either a login form (default) or a register form
             *
             * @required - Boolean; Determines if login is required
             * @destination - String; location to send the user after login/registration
             * @allowregister - Boolean; Determines if user registration is allowed
             * @showregister - Boolean; Determines if the registration form is shown (allowregister must also be true)
             */
            s.login = function (required, destination, allowregister, showregister) {

                if(window.sug_memberinfo.ISSSOUSER) {
                    window.location.href = '/register';
                    return false;
                }

                var deferred = $q.defer();
                var loginRequired = typeof required !== 'undefined' ? required : false;

                // possible overrides for forcing user to Register (part of email gating changes)
                s.allowRegistration = allowregister ? allowregister : true;
                s.showregistrationfirst = showregister ? showregister : false;
                var loginWindow = modal.open({
                    templateUrl: '/view/templates/main/login.html',
                    controller: 'authenticationController',
                    resolve: {
                        loginRequired: function () {
                            return loginRequired;
                        },
                        loginMessage: function () {
                            return '';
                        },
                        register: function () {
                            return (!s.user.loggedin && s.showregistrationfirst && s.allowRegistration);
                        },
                        registerDisabled: function () {
                            return !s.allowRegistration;
                        },
						otherLogins: function () {
							return true;
						}
                    }

                });

                loginWindow.result.then(function (response) {
                    var r = response;

                    if (isD(r.status) && r.status === 'loggedin' && isD(r.data) && isD(r.data.memberid) && parseInt(r.data.memberid) > 0) {
                        s.user = r.data;
                        s.user.loggedin = true;
                        // update upper main navigation menus
                        updateMenu();

                        //hooray go to the destination
                        if (destination !== undefined && destination !== '') {
                            win.location.href = destination;
                        }

                        deferred.resolve(true);
                    }
                }, function (e) {
                    deferred.reject(e);
                });

                return deferred.promise;
            };

            if (s.allowRegistration) {
                s.register = function () {
                    modal.open({
                        templateUrl: '/view/templates/main/login.html',
                        controller: 'authenticationController',
                        resolve: {
                            loginRequired: function () {
                                return false;
                            },
                            loginMessage: function () {
                                return '';
                            },
                            register: function () {
                                return true;
                            },
                            registerDisabled: function () {
                                return false;
                            }
                        }
                    }).result.then(function (response) {
                        var r = response;
                        if (isD(r.status) && r.status === 'loggedin' && isD(r.data) && isD(r.data.memberid) && parseInt(r.data.memberid) > 0) {
                            s.user = r.data;
                            s.user.loggedin = true;
                            // update upper main navigation menus
                            updateMenu();
                        }
                    });
                };
            }

            return s;
        };

        return service;

    }]);

})();